import React, { useEffect, useState } from "react";
import DoneImage from "../Components/assets/Images/congratsdoneimage.svg";
import Completedstyles from "../pages/Styles/Completed.module.scss";
import { LoadingButton } from "@mui/lab";
import GooglePlayStore from "../Components/assets/Images/GooglePlayStore.svg";
import AppStore from "../Components/assets/Images/AppStore.svg";
import MicroSoft from "../Components/assets/Images/MicrosoftStore.svg";

export default function CompletedPage() {
  const ClientCode = sessionStorage.getItem("client_id");

  return (
    <div className={Completedstyles.mainWrapperTop}>
      <div className={Completedstyles.wrapper}>
        <div className={Completedstyles.step}>
          <img src={DoneImage} />
        </div>
        <div className={Completedstyles.container}>
          <p className={Completedstyles.header}>Congratulations!</p>
          <p className={Completedstyles.header}>Your Account is Active</p>

          <div className={Completedstyles.textdiv}>
            <p className={Completedstyles.instructiontext}>
              <span>User ID is {ClientCode}</span>
              <span>
                The login credentials have been sent to your email address.
              </span>
            </p>
          </div>

          <div className={Completedstyles.shareSection}>
            <div className={Completedstyles.appstoreSection}>
              <p className={Completedstyles.sharetext}>
                Introducing our Firstock apps
              </p>
              <div className={Completedstyles.appContainer}>
                <a
                  href="https://play.google.com/store/apps/details?id=in.firstock.mobile"
                  target="_blank"
                >
                  <img
                    src={GooglePlayStore}
                    className={Completedstyles.Googlestoreimage}
                  />
                </a>

                <a
                  href="https://apps.apple.com/us/app/firstock-trade-invest/id6746480444"
                  target="_blank"
                >
                  <img
                    src={AppStore}
                    className={Completedstyles.Appstoreimage}
                  />
                </a>

                <a href="https://firstock-common.s3.ap-south-1.amazonaws.com/app/Firstock_INV_Live_Firstock_2023.7.4-setup.zip">
                  <img
                    src={MicroSoft}
                    className={Completedstyles.Microstoreimage}
                  />
                </a>
              </div>
            </div>
          </div>

          <div>
            <LoadingButton
              id="tradingPreferencesContinueButton"
              variant="contained"
              type="submit"
              className={Completedstyles.approveButton}
              style={{ width: "187px", height: "50px" }}
              onClick={() => {
                window.open("https://app.firstock.in/login", "_blank");
              }}
            >
              Login
            </LoadingButton>
          </div>
        </div>
      </div>
    </div>
  );
}
